goog.provide('el8.app.onboarding.statusHeadline');

goog.require('el8.appservice.headline');
goog.require('el8.data.currUser');
goog.require('el8.template.app.onboarding.statusHeadline');
goog.require('el8.service.urls');
goog.require('el8.app.onboarding.activateAccount');
goog.require('el8.app.onboarding.learnMore');


el8.app.onboarding.statusHeadline = (function() {

    /**
     * Set up headline for user global CTA's
     */
    return {
        display: function() {
            var isOnboardingPasswordResetPage = window.location.href.indexOf('/onboarding/registration/') !== -1; 

            if (el8Globals.PASSPORT_EMR) {
                (new el8.appservice.headline({
                    wrapperFn: el8.template.app.onboarding.statusHeadline.wrapper,
                    wrapperId: 'page-headline',
                    contentFn: function() {
                        return el8.template.app.onboarding.statusHeadline.passportEmrContent();
                    },
                    clickMap: {
                        'activate-account': function(elt) {
                            el8.app.onboarding.activateAccount.show();
                        },
                        'learn-more': function(elt) {
                            el8.app.onboarding.learnMore.show();
                        }
                    }
                })).show();
                $('body').on('click', '.demo-patient-badge',  function() {
                    el8.app.onboarding.activateAccount.show();
                });
                return true;

            } else if (!el8.data.currUser.isSelfOnboarding() && !el8.data.currUser.isPracticeAuthenticated() && el8.data.currUser.isPhysician()) {
                (new el8.appservice.headline({
                    wrapperFn: el8.template.app.onboarding.statusHeadline.wrapper,
                    wrapperId: 'page-headline',
                    contentFn: function() {
                        return el8.template.app.onboarding.statusHeadline.testAccountContent();
                    },
                    clickMap: {
                        'activate-account': function(elt) {
                            el8.app.onboarding.activateAccount.show();
                        },
                        'learn-more': function(elt) {
                            el8.app.onboarding.learnMore.show();
                        }
                    }
                })).show();
                $('body').on('click', '.demo-patient-badge',  function() {
                    el8.app.onboarding.activateAccount.show();
                });
                return true;

            } else if (!el8.data.currUser.isEmailVerified() && el8.data.currUser.isPhysician() && !isOnboardingPasswordResetPage) {
                (new el8.appservice.headline({
                    wrapperFn: el8.template.app.onboarding.statusHeadline.wrapper,
                    wrapperId: 'page-headline',
                    contentFn: function() {
                        return el8.template.app.onboarding.statusHeadline.needEmailVerified({
                            name: 'need-email-verify'
                        });
                    },
                    clickMap: {
                        'need-email-verify': function(elt) {
                            el8.appservice.notifier.notify('Sending email...');
                            $.el8_ajax({
                                type: 'POST',
                                url: el8.service.urls.get('resendVerifyEmail'),
                                success: function() {
                                    el8.appservice.notifier.notify('Email sent!');
                                },
                                error: function() {
                                    el8.appservice.notifier.notify('Sorry, email failed to send. Please try again.');
                                }
                            });
                        }
                    }
                })).show();
                return true;

            } else if (!el8Globals.FEATURES.InAppProviderOnboard && !el8.data.currUser.isCredentialed() && el8.data.currUser.isPhysician() ) {
                var bannerContentFn = function() {
                    return el8.template.app.onboarding.statusHeadline.needCredentials({
                        name: 'need-credentials'
                    });
                };
                // check if the credentials docs are already uploaded
                if (el8.data.currUser.isCredentialDocumentsUploaded()) {
                    bannerContentFn = function() {
                        return el8.template.app.onboarding.statusHeadline.needCredentialDocumentsReview();
                    };
                }
                (new el8.appservice.headline({
                    wrapperFn: el8.template.app.onboarding.statusHeadline.wrapper,
                    wrapperId: 'page-headline',
                    contentFn: bannerContentFn
                })).show();
                return true;
            }

            return false;
        }
    };

})();
